'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConnect = exports.getActions = exports.createGetActions = exports.cacheKey = exports.getFieldPropOr = exports.getFieldProp = exports.getFieldState = exports.getEntityPrefix = exports.withEntity = exports.prefixProps = undefined;

var _getOr2 = require('lodash/fp/getOr');

var _getOr3 = _interopRequireDefault(_getOr2);

var _at2 = require('lodash/fp/at');

var _at3 = _interopRequireDefault(_at2);

var _stubTrue2 = require('lodash/stubTrue');

var _stubTrue3 = _interopRequireDefault(_stubTrue2);

var _property2 = require('lodash/property');

var _property3 = _interopRequireDefault(_property2);

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _overArgs2 = require('lodash/overArgs');

var _overArgs3 = _interopRequireDefault(_overArgs2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _method2 = require('lodash/method');

var _method3 = _interopRequireDefault(_method2);

var _memoize2 = require('lodash/memoize');

var _memoize3 = _interopRequireDefault(_memoize2);

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _filter2 = require('lodash/filter');

var _filter3 = _interopRequireDefault(_filter2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _cond2 = require('lodash/cond');

var _cond3 = _interopRequireDefault(_cond2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.mapDispatchToProps = mapDispatchToProps;
exports.mergeProps = mergeProps;
exports.addPrefix = addPrefix;

var _reactRedux = require('react-redux');

var _reduxGraph = require('redux-graph');

var _reduxField = require('redux-field');

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @TODO Default values needed for prefixProps? Not for now.
// Create builder that accepts prefixProps array if required.
function mapDispatchToProps(getActions) {
  return function (dispatch, props) {
    return _extends({ dispatch: dispatch }, (0, _redux.bindActionCreators)(getActions(props), dispatch));
  };
}
var prefixProps = exports.prefixProps = ['collectionId', 'fieldId'];
var withEntity = exports.withEntity = (0, _partial3.default)(_flow3.default, (0, _property3.default)('entity'));
var getEntityPrefix = exports.getEntityPrefix = (0, _cond3.default)([[(0, _property3.default)('prefix'), (0, _property3.default)('prefix')], [withEntity(_reduxGraph.isEntityCreated), withEntity((0, _at3.default)(['type', 'id']))], [_stubTrue3.default, (0, _flow3.default)((0, _at3.default)(prefixProps), _filter3.default)]]);
var getFieldState = exports.getFieldState = (0, _overArgs3.default)(_get3.default, [_reduxField.selectForm, getEntityPrefix]);
var getFieldProp = exports.getFieldProp = (0, _flow3.default)(_property3.default, (0, _partial3.default)(_flow3.default, getFieldState));
var getFieldPropOr = exports.getFieldPropOr = (0, _flow3.default)(_getOr3.default, (0, _partial3.default)(_flow3.default, getFieldState));

// Assume the actions never change for the life of component?
var cacheKey = exports.cacheKey = (0, _flow3.default)(getEntityPrefix, (0, _method3.default)('join', '-'));
var createGetActions = exports.createGetActions = function createGetActions(actions) {
  return (0, _flow3.default)(getEntityPrefix, (0, _memoize3.default)((0, _reduxField.mapPartial)(actions), cacheKey));
};

var getActions = exports.getActions = (0, _flow3.default)(createGetActions, mapDispatchToProps);
// Remove the props used to create the redux-field prefix.
function mergeProps(stateProps, dispatchProps, ownProps) {
  var props = (0, _omit3.default)(ownProps, ['collectionId']);
  return Object.assign(props, stateProps, dispatchProps);
}
function addPrefix(mapStateToProps) {
  return function (state, props) {
    return _extends({}, mapStateToProps(state, props), { prefix: getEntityPrefix(props) });
  };
}
// modify actionObject and add our custom mergeProps onto standard redux connect().
var createConnect = exports.createConnect = function createConnect(mapStateToProps, actions) {
  return (0, _reactRedux.connect)(addPrefix(mapStateToProps), (0, _isPlainObject3.default)(actions) ? getActions(actions) : actions, mergeProps);
};


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/capeField.js
// module id = 208
// module chunks = 0